(function () {
  const drawer = document.getElementById("cart-drawer");
  const overlay = document.getElementById("cart-drawer-overlay");
  if (!drawer) return;

  function setAddToCartButtonState(button, state) {
    if (!button) return;

    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = button.textContent.trim() || "Add to Cart";
    }

    button.classList.remove("is-loading", "is-added");
    button.removeAttribute("aria-busy");

    if (state === "loading") {
      button.classList.add("is-loading");
      button.setAttribute("aria-busy", "true");
      button.textContent = "Adding...";
      return;
    }

    if (state === "added") {
      button.classList.add("is-added");
      button.textContent = "Added to cart";
      return;
    }

    button.textContent = button.dataset.defaultLabel;
  }

  const openButtons = document.querySelectorAll("[data-open-cart]");
  const closeButtons = drawer.querySelectorAll("[data-close-cart]");

  function openCart() {
    drawer.setAttribute("aria-hidden", "false");
    overlay?.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-open");
    refreshCart();
  }

  function closeCart() {
    drawer.setAttribute("aria-hidden", "true");
    overlay?.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-open");
  }

  openButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openCart();
    });
  });

  closeButtons.forEach((btn) => btn.addEventListener("click", closeCart));
  overlay?.addEventListener("click", closeCart);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCart();
  });

  async function refreshCart() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = String(cart.item_count || 0);
      });
      const subtotal = drawer.querySelector("[data-cart-subtotal]");
      if (subtotal && typeof cart.total_price === "number") {
        subtotal.textContent = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: cart.currency || "LKR",
        }).format(cart.total_price / 100);
      }
    } catch (error) {
      console.error("Failed to refresh cart", error);
    }
  }

  document.addEventListener("click", async (event) => {
    const removeBtn = event.target.closest("[data-remove-item]");
    const qtyBtn = event.target.closest("[data-change-qty]");

    if (removeBtn) {
      const key = removeBtn.getAttribute("data-remove-item");
      if (!key) return;
      await updateCartByKey(key, 0);
      return;
    }

    if (qtyBtn) {
      const key = qtyBtn.getAttribute("data-change-qty");
      const qty = Number(qtyBtn.getAttribute("data-qty"));
      if (!key || Number.isNaN(qty) || qty < 0) return;
      await updateCartByKey(key, qty);
    }
  });

  async function updateCartByKey(key, quantity) {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      await rerenderCartDrawer();
      await refreshCart();
    } catch (error) {
      console.error("Cart update failed", error);
    }
  }

  async function rerenderCartDrawer() {
    try {
      const response = await fetch("/?sections=cart-drawer");
      const sections = await response.json();
      const sectionHTML = sections["cart-drawer"];
      if (!sectionHTML) return;
      const parsed = new DOMParser().parseFromString(sectionHTML, "text/html");
      const newBody = parsed.querySelector("[data-cart-items]");
      const newSubtotal = parsed.querySelector("[data-cart-subtotal]");
      const currentBody = drawer.querySelector("[data-cart-items]");
      const currentSubtotal = drawer.querySelector("[data-cart-subtotal]");
      if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;
      if (newSubtotal && currentSubtotal)
        currentSubtotal.textContent = newSubtotal.textContent;
    } catch (error) {
      console.error("Failed to rerender cart drawer", error);
    }
  }

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest('form[action="/cart/add"]');
    if (!form) return;
    event.preventDefault();

    const submitBtn = form.querySelector("[data-add-to-cart]");
    const wasDisabled = submitBtn?.hasAttribute("disabled");
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
      setAddToCartButtonState(submitBtn, "loading");
    }

    try {
      const formData = new FormData(form);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      if (!response.ok) {
        let msg = "Could not add this item to cart. Please try again.";
        try {
          const err = await response.json();
          if (err.description) msg = err.description;
          else if (err.message) msg = err.message;
        } catch (_) {}
        throw new Error(msg);
      }

      openCart();
      await rerenderCartDrawer();
      await refreshCart();

      if (submitBtn) {
        setAddToCartButtonState(submitBtn, "added");
        setTimeout(() => {
          setAddToCartButtonState(submitBtn, "idle");
          if (!wasDisabled) {
            submitBtn.removeAttribute("disabled");
          }
        }, 1100);
      }
    } catch (error) {
      console.error(error);
      alert(error.message || "Could not add this item to cart. Please try again.");
      if (submitBtn) {
        setAddToCartButtonState(submitBtn, "idle");
      }
    } finally {
      if (
        submitBtn &&
        !submitBtn.classList.contains("is-added") &&
        !wasDisabled
      ) {
        submitBtn.removeAttribute("disabled");
      }
    }
  });
})();
